<template>
    <client-page class="wrap--mypage">
        <v-container>
                <div class="mypage-container">
                    <!-- 네비게이션 메뉴 -->
                    <mypage-navigation />
                    <!-- 페이지 콘텐츠 -->
                    <div class="mypage-contents">
                        <div class="tit-wrap tit-wrap--unberline">
                            <h2 class="tit">위탁신청내역</h2>
                        </div>

                        <form-view code="consignment-sale" skin="consignment-sale" />
                    </div>
                </div>
        </v-container>
    </client-page>
</template>

<script>
import FormView from "@/components/client/ko/form/form-view.vue";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import MypageNavigation from "@/components/client/ko/mypage-navigation.vue";

export default {
    components: {
        FormView,
        ClientPage,
        MypageNavigation,
    },
};
</script>
